import React from 'react';
import PropTypes from 'prop-types';
import makeStyles from 'housecall-ui/dist/DesignSystem/Styles/makeStyles';

import Button from 'housecall-ui/dist/DesignSystem/Inputs/Buttons/Button';
import Grid from 'housecall-ui/dist/DesignSystem/Layout/Grid/Grid';
import Popover from 'housecall-ui/dist/DesignSystem/DataDisplay/Popover/Popover';
import AppsShortcuts from './AppsShortcuts';

const useStyles = makeStyles(() => ({
  appGrid: {
    padding: 12,
    width: 320,
  },
  popover: {
    marginTop: 8,
  },
}));

function AppsPopoverDialog({
  apps,
  open,
  anchorEl,
  onClose,
}) {
  const { appGrid, popover } = useStyles();

  return (
    <Popover
      open={open}
      anchorEl={anchorEl}
      anchorOrigin={{ horizontal: 'center', vertical: 'bottom' }}
      transformOrigin={{ horizontal: 'center', vertical: 'top' }}
      onClose={onClose}
      className={popover}
    >
      <Grid container className={appGrid}>
        <Grid item xs={12}>
          <AppsShortcuts apps={apps} onAppClick={onClose} />
        </Grid>
        <Grid item xs={12} align="center">
          <Button color="secondary" href="/pro/apps">
            Go to App store
          </Button>
        </Grid>
      </Grid>
    </Popover>
  );
}

AppsPopoverDialog.propTypes = {
  apps: PropTypes.arrayOf(PropTypes.object),
  open: PropTypes.bool.isRequired,
  anchorEl: PropTypes.element,
  onClose: PropTypes.func.isRequired,
};

export default AppsPopoverDialog;
